import { awaitConsentStatistic, hasConsentStatistic } from "./consents";

export type EventData = { event: string };

type ExtendedDataLayerObject = Array<EventData> & {
    pushStashed: (obj: EventData) => void;
};

type UnitializedGoogleTagManager = {
    dataLayer: undefined | Array<EventData> | ExtendedDataLayerObject;
};

// This could maybe even be in sessionStore?
const queue: Array<EventData> = [];

export function push(data: EventData) {
    if (hasConsentStatistic()) {
        const w = globalThis as unknown as UnitializedGoogleTagManager;

        w.dataLayer?.push(data);
    } else {
        queue.push(data);
    }
}

export default function initGoogleTagManager() {
    const w = globalThis as unknown as UnitializedGoogleTagManager;
    w.dataLayer = w.dataLayer || [];

    awaitConsentStatistic().then(() => {
        while (queue.length > 0) {
            const itm = queue.shift();
            if (itm) {
                w.dataLayer?.push(itm);
            }
        }
    });
}
